export interface LinearGraphElement {
  backgroundType: 'color' | 'image';
  outerWrapperBcg: string;
  innerWrapperBcg: string;
}

export enum PAGES {
  HOME = '/',
  SIGN_UP = 'sign-up',
  SIGN_IN = 'sign-in',
  FORGOT_PAS = 'forgot-password',
  RESET_PAS = 'reset-password',
  CREATE_PASSWORD = 'create-password',
  SENT_EM_SUCCESS = 'sent-email-success',
  LIBRARY = 'library',
  COURSES = 'courses',
  PROFILE = 'profile',
  ONBOARDING = 'onboarding',
}

export enum PROFILE_PAGES {
  ACCOUNT = 'account-info',
  CONTACT = 'contact-us',
  CHANGE_PASS = 'change-password',
  PAYMENT_DETAILS = 'payment-details',
  REMINDERS = 'reminders',
}
